import React from 'react';
import { Badge, Table } from 'reactstrap';
import moment from 'moment';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';
import SortableTh from '@src/components/SortableTh/SortableTh';

const StatusLabel = props => {
  const { item } = props;
  let color = 'danger';
  let label = 'Submitted';
  if (item.approved === -1) {
    color = 'secondary';
    label = 'Denied';
  } else if (item.status === 1) {
    color = 'success';
    label = 'Delivered';
  } else if (item.qb_invoice_paid === 1) {
    color = 'warning';
    label = 'Paid';
  } else if (item.qb_invoice_id > 0) {
    color = 'warning';
    label = 'Invoiced';
  } else if (item.approved === 1) {
    color = 'warning';
    label = 'Approved';
  }
  return (
    <Badge color={color} className={'text-uppercase'}>
      {label}
    </Badge>
  );
};

export default props => {
  return (
    <Table className={'mt-3'} hover={true}>
      <thead>
        <tr>
          <SortableTh
            {...props}
            label={'Issue Date'}
            field={'EvidenceOfInsurances.issue_date'}
          />
          <SortableTh
            {...props}
            label={'Reference #'}
            field={'EvidenceOfInsurances.ref_number'}
          />
          <SortableTh
            {...props}
            label={'Homeowner'}
            field={'EvidenceOfInsurances.owner'}
          />
          <SortableTh
            {...props}
            label={'Property Address'}
            field={'EvidenceOfInsurances.address'}
          />
          <SortableTh
            {...props}
            label={'Loan Number'}
            field={'EvidenceOfInsurances.loan_number_1'}
          />
          <SortableTh
            {...props}
            label={'Invoice Status'}
            field={'EvidenceOfInsurances.qb_invoice_paid'}
          />
          <SortableTh
            {...props}
            label={'Status'}
            field={'EvidenceOfInsurances.status'}
          />
          <th>
            Internal
            <br />
            Notes
          </th>
        </tr>
      </thead>
      <tbody>
        {props.list.map(item => {
          const issueDate = moment(item.issue_date * 1000).format('MM/DD/YYYY');

          let sentDate = '';
          if (item.sent_date > 0) {
            if (moment(item.sent_date * 1000).isSame(moment(), 'day')) {
              sentDate =
                'Today, ' + moment(item.sent_date * 1000).format('h:mmA');
            } else if (
              moment(item.sent_date * 1000).isSame(
                moment().subtract(1, 'days'),
                'day'
              )
            ) {
              sentDate =
                'Yesterday, ' + moment(item.sent_date * 1000).format('h:mmA');
            } else {
              sentDate = moment(item.sent_date * 1000).format(
                'MM/DD/YYYY h:mmA'
              );
            }
          }

          return (
            <tr
              className={'pointer'}
              key={'eoi-' + item.id}
              onClick={() => props.onEntityClick(item.id)}
            >
              <td className={'text-nowrap'}>{issueDate}</td>
              <td className={'text-nowrap'}>
                {item.evidence_of_insurance_form !== null
                  ? item.evidence_of_insurance_form.external_id
                  : ''}
              </td>
              <td>
                {item.owner_first_name !== null && (
                  <React.Fragment>
                    {`${item.owner_first_name} ${item.owner_last_name}`}{' '}
                    {item.second_owner_first_name.length > 0 && (
                      <React.Fragment>
                        and {item.second_owner_first_name}{' '}
                        {item.second_owner_last_name}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </td>
              <td>
                {item.master_cert_only === 1 && (
                  <div>
                    <Badge color={'primary'}>Master Certificate Only</Badge>
                  </div>
                )}
                {item.unit !== null && (
                  <React.Fragment>
                    {item.unit.address_no}, {item.unit.street},{' '}
                    {item.unit.unit_no}
                    <br />
                    <AddressHelper
                      {...item.association}
                      address_line_1={null}
                      address_line_2={null}
                    />
                  </React.Fragment>
                )}
              </td>
              <td>{item.loan_number_1}</td>
              <td>
                {item.qb_invoice_id > 0 && (
                  <span className={'d-block'}>#{item.qb_invoice_number}</span>
                )}
                {item.qb_invoice_id > 0 ? (
                  item.qb_invoice_paid === 1 ? (
                    <Badge color={'success'} className={'clear'}>
                      PAID
                    </Badge>
                  ) : (
                    <React.Fragment>
                      <Badge color={'danger'}>UNPAID</Badge>
                      <br />
                      {item.qb_invoice_sent === 1 ? (
                        <Badge color={'success'}>SENT</Badge>
                      ) : (
                        <Badge color={'danger'}>UNSENT</Badge>
                      )}
                    </React.Fragment>
                  )
                ) : (
                  ''
                )}
                {item.pre_pay === 1 && item.qb_invoice_paid === 0 && (
                  <span className={'d-block'}>
                    <Badge color={'danger'}>PRE-PAY</Badge>
                  </span>
                )}
                {item.pre_pay === 1 &&
                  item.qb_invoice_paid === 1 &&
                  item.status === 0 && (
                    <span className={'d-block'}>
                      <Badge color={'success'}>PRE-PAID</Badge>
                    </span>
                  )}
              </td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <StatusLabel item={item} />
                {item.status === 0 && (
                  <React.Fragment>
                    {item.scheduled_email !== null && (
                      <React.Fragment>
                        Scheduled
                        <br />
                        <span className={'d-block'}>
                          {moment(
                            item.scheduled_email.scheduled_date * 1000
                          ).format('MM/DD/YYYY h:mmA')}
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
                {item.pending === 1 && (
                  <React.Fragment>
                    <br />
                    <Badge color={'warning'} className={'text-uppercase'}>
                      PENDING
                    </Badge>
                  </React.Fragment>
                )}
                {item.on_hold_internal === 1 && (
                  <React.Fragment>
                    <br />
                    <Badge color={'warning'} className={'text-uppercase'}>
                      ON HOLD - INTERNAL
                    </Badge>
                  </React.Fragment>
                )}

                {sentDate.length > 0 && (
                  <React.Fragment>
                    <br />
                    <span className={'d-block'}>{sentDate}</span>
                  </React.Fragment>
                )}
              </td>
              <td>{item.notes}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
